import { toTimezone } from 'utils/dateTimeUtils';
import { RESET_REPORTLIST_STORE } from 'views/ReportList/flow/actionTypes';
import { SET_ACTIVE_TAB } from 'views/ReportListSider/flow/actionTypes';
import { SET_FILES, SYNC_AFTER_DELETE } from './actionTypes';

const files = (state = [], action) => {
  switch (action.type) {
    case SET_FILES:
      return action.payload.files.map(f => ({
        id: f.id,
        name: f.name,
        createdAt: toTimezone(f.created_at, true),
        createdBy: '',
        lastModifiedBy: '',
        type: f.type
      }));

    case SYNC_AFTER_DELETE:
      return state.filter(f => f.id !== action.payload.id);

    case RESET_REPORTLIST_STORE:
      return [];

    case SET_ACTIVE_TAB:
      return [];

    default:
      return state;
  }
};

export default files;



// WEBPACK FOOTER //
// ./src/views/ReportListPanel/flow/reducer.js